import { render, staticRenderFns } from "./AppAudioMsgWrap.vue?vue&type=template&id=bf83cfd0&scoped=true&"
import script from "./AppAudioMsgWrap.vue?vue&type=script&lang=js&"
export * from "./AppAudioMsgWrap.vue?vue&type=script&lang=js&"
import style0 from "./AppAudioMsgWrap.vue?vue&type=style&index=0&id=bf83cfd0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf83cfd0",
  null
  
)

export default component.exports